@if (loaded) {
  <div>
    @if (layoutype==0) {
      <div>
        <div class="container pad">
          <p [innerHTML]="aboutData"> </p>
        </div>
      </div>
    }
    @if (layoutype==1) {
      <div>
        <calsoft-layout [value]="3"  [pageNated]="true" [homePageData]="homePageBuilder" [type]="2"></calsoft-layout>
      </div>
    }
  </div>
}